import NeedsAttentionIcon from './needs_attention.svg';
import CompletedIcon from './completed.svg';

const Icons = { NeedsAttention: NeedsAttentionIcon, Completed: CompletedIcon };

export default Icons;
